import script from "./CouponForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponForm.vue?vue&type=script&setup=true&lang=js"

import "./CouponForm.vue?vue&type=style&index=0&id=19653ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19653ab6"]])

export default __exports__